import { Search } from 'lucide-react';

export interface FilterInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
}

export default function FilterInput({
  value,
  onChange,
  placeholder = 'Rechercher…',
  className = '',
  id = 'filter-input',
}: FilterInputProps) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden />
      <input
        id={id}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pro-input w-full min-w-[200px] pl-9 sm:max-w-xs"
        aria-label={placeholder}
      />
    </div>
  );
}
